// Shared language preference for the legal/consent surfaces (EN/DE only).
export const LANG_KEY = 'glimt_legal_lang';

export function getInitialLang() {
  try {
    const saved = localStorage.getItem(LANG_KEY);
    if (saved === 'en' || saved === 'de') return saved;
  } catch (_) {}
  const nav = (typeof navigator !== 'undefined' && navigator.language) || 'en';
  return nav.toLowerCase().startsWith('de') ? 'de' : 'en';
}

export function setStoredLang(lang) {
  try {
    localStorage.setItem(LANG_KEY, lang);
  } catch (_) {}
}
